import { render, staticRenderFns } from "./GlobalForm.vue?vue&type=template&id=b45ee834&scoped=true"
import script from "./GlobalForm.vue?vue&type=script&lang=js"
export * from "./GlobalForm.vue?vue&type=script&lang=js"
import style0 from "./GlobalForm.vue?vue&type=style&index=0&id=b45ee834&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45ee834",
  null
  
)

export default component.exports